import * as yup from 'yup';

export const schema = yup.object().shape({
  url_redirect: yup.string(),
  title: yup.string().required('O Título é obrigatório.'),
  type: yup.string().required('O tipo da propaganda é obrigatório.'),
  target_audience: yup.string().required('O tipo de Público é obrigatório!'),
});
